import { render } from "./FormPage.vue?vue&type=template&id=1d0494e8&scoped=true"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"

import "./FormPage.vue?vue&type=style&index=0&id=1d0494e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0494e8"],['__file',"src/views/AfterSales/applyAfterSalesAndsubFunc/FormPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d0494e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d0494e8', __exports__)) {
    api.reload('1d0494e8', __exports__)
  }
  
  module.hot.accept("./FormPage.vue?vue&type=template&id=1d0494e8&scoped=true", () => {
    api.rerender('1d0494e8', render)
  })

}


export default __exports__